import React from "react";
import ApprovalMatrixConfig from "../../config/ApprovalMatrixConfig";

const BranchSettingsInfo = ({
  formData,
  updateField,
  approvalMatrix,
  onApprovalMatrixChange,
}) => {
  return (
    <div className="space-y-6">
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-semibold mb-3">Transaction Settings</h4>
        <div className="space-y-2">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={formData.settings.allowCrossBranchRedemption}
              onChange={(e) =>
                updateField(
                  "settings",
                  "allowCrossBranchRedemption",
                  e.target.checked
                )
              }
              className="h-4 w-4 text-blue-600 rounded mr-2"
            />
            <span className="text-sm">Allow cross-branch redemption</span>
          </label>
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={formData.settings.allowInterBranchTransfer}
              onChange={(e) =>
                updateField(
                  "settings",
                  "allowInterBranchTransfer",
                  e.target.checked
                )
              }
              className="h-4 w-4 text-blue-600 rounded mr-2"
            />
            <span className="text-sm">Allow inter-branch transfer</span>
          </label>
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={formData.settings.allowRateOverride}
              onChange={(e) =>
                updateField("settings", "allowRateOverride", e.target.checked)
              }
              className="h-4 w-4 text-blue-600 rounded mr-2"
            />
            <span className="text-sm">Allow rate override</span>
          </label>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            High Value Threshold (₹)
          </label>
          <input
            type="number"
            value={formData.settings.highValueThreshold}
            onChange={(e) =>
              updateField(
                "settings",
                "highValueThreshold",
                parseInt(e.target.value) || 0
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
          <label className="flex items-center mt-2">
            <input
              type="checkbox"
              checked={formData.settings.requiresApprovalForHighValue}
              onChange={(e) =>
                updateField(
                  "settings",
                  "requiresApprovalForHighValue",
                  e.target.checked
                )
              }
              className="h-4 w-4 text-blue-600 rounded mr-2"
            />
            <span className="text-sm">Require approval for high value</span>
          </label>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Max Discount (%)
          </label>
          <input
            type="number"
            value={formData.settings.maxDiscountPercent}
            onChange={(e) =>
              updateField(
                "settings",
                "maxDiscountPercent",
                parseInt(e.target.value) || 0
              )
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
            min="0"
            max="100"
          />
          <label className="flex items-center mt-2">
            <input
              type="checkbox"
              checked={formData.settings.discountApprovalRequired}
              onChange={(e) =>
                updateField(
                  "settings",
                  "discountApprovalRequired",
                  e.target.checked
                )
              }
              className="h-4 w-4 text-blue-600 rounded mr-2"
            />
            <span className="text-sm">Require approval</span>
          </label>
          {formData.settings.discountApprovalRequired && (
            <input
              type="number"
              value={formData.settings.discountApprovalThreshold}
              onChange={(e) =>
                updateField(
                  "settings",
                  "discountApprovalThreshold",
                  parseInt(e.target.value) || 0
                )
              }
              className="w-full px-2 py-1 border border-gray-300 rounded mt-2"
              placeholder="Approval threshold %"
              min="0"
              max="100"
            />
          )}
        </div>
      </div>

      <ApprovalMatrixConfig
        approvalMatrix={approvalMatrix}
        onChange={onApprovalMatrixChange}
        viewOnly={false}
      />
    </div>
  );
};

export default BranchSettingsInfo;
